<script setup>
  import { ref, computed, onMounted } from "vue";
  import { useRouter } from "vue-router";
  import { useMasterReportsStore } from "@stores/masterReports/masterReports";
  import { usePptxImportStore } from "@stores/pptxImport";
  import { useAccountsStore } from "@stores/accounts";
  import MasterReportForm from "@/components/Reports/MasterReports/MasterReportForm.vue";

  const router = useRouter();

  const masterReportsStore = useMasterReportsStore();
  const pptxImportStore = usePptxImportStore();
  const accountsStore = useAccountsStore();

  const creating = ref(false);
  const error = ref(null);

  const accountOptions = computed(() =>
    (accountsStore.accounts ?? []).map((a) => ({ value: String(a.id), label: a.name })),
  );

  onMounted(() => {
    accountsStore.fetch();
  });

  async function handleCreate({ name, file, accountIds, isSystem }) {
    creating.value = true;
    error.value = null;

    try {
      const masterReport = await masterReportsStore.createMasterReport({
        name,
        ...(accountIds?.length ? { account_ids: accountIds } : {}),
        ...(isSystem ? { is_system: true } : {}),
      });

      pptxImportStore.setThemeToken(masterReport.token);

      const success = await pptxImportStore.analyze(file);

      if (success) {
        router.push({ name: "MasterReportSlides", params: { themeToken: masterReport.token } });
      } else {
        error.value = pptxImportStore.analyzeError || "Failed to analyze PPTX";
      }
    } catch (e) {
      console.error("Failed to create master report:", e);
      error.value = e.message || "Failed to create master report";
    } finally {
      creating.value = false;
    }
  }
</script>

<template>
  <div class="flex justify-center p-4">
    <MasterReportForm
      mode="create"
      :account-options="accountOptions"
      :submitting="creating"
      :error="error"
      @submit="handleCreate" />
  </div>
</template>
